<template>
  <v-container>
    <v-row justify="center" class="pr-0 pl-0 mx-1" no-gutters>
      <v-col cols="12" sm="8">
        <v-sheet rounded="lg" elevation="5" class="pa-2 mt-1">
          <v-row justify="space-between" class="mx-3">
            <div>Información de la asistencia</div>
            <v-btn icon class="pa-0"
              ><i
                class="fas fa-sync-alt fa-2x"
                @click="listarAsistenciasActivas()"
              ></i
            ></v-btn>
          </v-row>
          <v-row justify="center">
            <v-col cols="auto">
              <v-select
                v-model="numeroAsistencia"
                label="Numero de asistencia"
                :items="items"
                :menu-props="{ bottom: true, offsetY: true }"
                @change="buscarAsistencia()"
              >
              </v-select>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="3" sm="3">
              <v-text-field
                v-model="placa"
                label="Placa"
                hide-details
                readonly
              ></v-text-field>
            </v-col>
            <v-col cols="3" sm="3">
              <v-text-field
                v-model="marca"
                label="marca"
                hide-details
                readonly
              ></v-text-field>
            </v-col>
            <v-col cols="3" sm="3">
              <v-text-field
                v-model="modelo"
                label="modelo"
                hide-details
                readonly
              ></v-text-field>
            </v-col>
            <v-col cols="3" sm="3">
              <v-text-field
                v-model="año"
                label="año"
                hide-details
                readonly
              ></v-text-field>
            </v-col>
          </v-row>
        </v-sheet>
      </v-col>
    </v-row>

    <v-row justify="center" class="pr-0 pl-0 mx-1">
      <v-col cols="12" sm="3" align-self="center">
        <v-sheet rounded="lg">
          <v-btn
            color="blue"
            rounded
            block
            elevation="9"
            :disabled="disabledContacto"
            @click="openDialogFecha(1)"
            >Contacto ></v-btn
          >
        </v-sheet>
      </v-col>

      <v-col cols="12" sm="5" align-self="center">
        <v-sheet rounded="lg">
          <v-text-field
            v-model="fechaContacto"
            label="Fecha Contacto"
            outlined
            step="1"
            hide-details
            readonly
          ></v-text-field>
        </v-sheet>
      </v-col>
    </v-row>

    <v-row justify="center" class="pr-0 pl-0 mx-1">
      <v-col cols="12" sm="3" align-self="center">
        <v-sheet rounded="lg">
          <v-btn
            color="blue"
            rounded
            block
            elevation="9"
            :disabled="disabledTermino"
            @click="openDialogFecha(2)"
            >Termino ></v-btn
          >
        </v-sheet>
      </v-col>

      <v-col cols="12" sm="5" align-self="center">
        <v-sheet rounded="lg">
          <v-text-field
            v-model="fechaTermino"
            label="Fecha Termino"
            outlined
            step="1"
            hide-details
            readonly
          ></v-text-field>
        </v-sheet>
      </v-col>

      <v-container>
        <v-card outlined width="auto" class="pa-2 mb-1" elevation="1">
          <v-card-title class="pa-0">Almacenamiento de archivos</v-card-title>
          <v-row justify="center" align="center">
            <v-col cols="12" md="5">
              <v-card max-width="500" class="mx-auto">
                <v-card-title>Cargar archivos</v-card-title>
                <v-card-actions>
                  <v-file-input
                    v-model="filesCargadas"
                    id="fileButtom"
                    accept="image/*, .mp3, .wav"
                    label="File input"
                    multiple
                    small-chips
                    :show-size="1000"
                    counter
                    @change="cargarArchivos()"
                  ></v-file-input>
                  <v-btn
                    :disabled="disabledCargarArchivos"
                    class="ml-3"
                    rounded
                    outlined
                    elevation="3"
                    color="blue"
                    @click="subirArchivos()"
                  >
                    <i class="fas fa-cloud-upload-alt fa-2x"></i>
                  </v-btn>
                </v-card-actions>
              </v-card>
            </v-col>
            <v-col cols="12" v-if="imagenesPreview.length > 0">
              <v-sheet elevation="8">
                <v-slide-group
                  v-model="model"
                  class="pa-4"
                  active-class="success"
                  center-active
                  show-arrows
                >
                  <v-slide-item v-for="(item, i) in imagenesPreview" :key="i">
                    <v-card class="ma-4" height="200" width="150">
                      <v-row class="fill-height" justify="center">
                        <v-scale-transition>
                          <v-img :src="item.url"></v-img>
                        </v-scale-transition>
                      </v-row>
                    </v-card>
                  </v-slide-item>
                </v-slide-group>
              </v-sheet>
            </v-col>
          </v-row>
        </v-card>
      </v-container>
    </v-row>

    <v-dialog v-model="dialogConfirmarFecha" width="500">
      <v-card>
        <v-card-title class="headline grey lighten-2">
          Establecer fecha
        </v-card-title>

        <v-card-text class="font-weight-black subtitle-1 text--primary my-auto">
          ¿Está seguro de colocar la fecha de {{ tituloFecha }}?
        </v-card-text>

        <v-divider></v-divider>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="primary" text @click="dialogConfirmarFecha = false">
            No
          </v-btn>
          <v-btn color="primary" text @click="fechaHoraContactoTermino()">
            Si, seguro
          </v-btn>
        </v-card-actions>
      </v-card>

      <v-overlay v-model="overlayDate" z-index="0">
        <lottie-player
          autoplay
          loop
          mode="normal"
          src="https://assets5.lottiefiles.com/datafiles/XpFCWApEzLI29va/data.json"
          style="width: 320px"
        >
        </lottie-player>
      </v-overlay>
    </v-dialog>

    <v-overlay v-model="overlay" z-index="0">
      <lottie-player
        autoplay
        loop
        mode="normal"
        src="https://assets5.lottiefiles.com/datafiles/XpFCWApEzLI29va/data.json"
        style="width: 320px"
      >
      </lottie-player>
    </v-overlay>

    <v-snackbar v-model="snackError" color="red darken-2" bottom left
      >SUCEDIO ALGUN ERROR, VERIFICAR ESTADO DE CONEXIÓN, Y VUELVA A
      INTENTAR.</v-snackbar
    >

    <v-snackbar v-model="snackArchivoSubido" color="cyan darken-2" bottom left
      >LOS ARCHIVOS SE CARGARON CON EXITO.</v-snackbar
    >

    <v-snackbar
      v-model="snackNumeroAsistencia"
      color="cyan darken-2"
      bottom
      left
      >DEBE DE COLOCAR EL NUMERO DE ASISTENCIA.</v-snackbar
    >

    <v-snackbar v-model="snackErrorContacto" color="cyan darken-2" bottom left
      >DEBE DE COLOCAR EL NUMERO DE ASISTENCIA Y LUEGO EN BUSCAR.</v-snackbar
    >

    <v-snackbar v-model="snackErrorTermino" color="cyan darken-2" bottom left
      >DEBE DE COLOCAR EL NUMERO DE ASISTENCIA Y LUEGO EN BUSCAR.</v-snackbar
    >
  </v-container>
</template>

<script>
import axios from "axios";
import { storage } from "../main";
export default {
  data() {
    return {
      items: [],
      idCabina: "",
      idBase: "",
      idUsuario: "",
      idProveedor: "",
      numeroAsistencia: "",
      placa: "",
      marca: "",
      modelo: "",
      año: "",
      fechaContacto: null,
      fechaTermino: null,
      disabledContacto: false,
      disabledTermino: false,
      overlay: false,
      overlayDate: false,
      snackError: false,
      dialogConfirmarFecha: false,
      banderaContactoTermino: 0,
      tituloFecha: "",
      //para archivos
      filesCargadas: [],
      imagenesPreview: [],
      filesDescargadasAudios: [],
      disabledCargarArchivos: true,
      model: null,
      snackArchivoSubido: false,
      snackNumeroAsistencia: false,
      snackErrorContacto: false,
      snackErrorTermino: false,
      mostrarBotonDescargar: false,
    };
  },
  created() {
    this.listarAsistenciasActivas();
  },
  methods: {
    listarAsistenciasActivas() {
      let me = this;
      let header = { Authorization: "Bearer " + this.$store.state.token };
      let configuracion = { headers: header };
      let usuario = me.$store.state.usuario.nombre.toUpperCase();
      me.limpiar();
      me.overlay = true;
      axios
        .get("api/Cabinas/Listar/", configuracion)
        .then(function(response) {
          response.data.forEach((item, index) => {
            let nombreProveedor = item.proveedor;
            if (usuario == nombreProveedor) {
              me.items.push(response.data[index].numeroAsistencia);
            }
          });
          me.overlay = false;
        })
        .catch(function(error) {
          console.log(error);
          me.overlay = false;
          me.snackError = true;
        });
    },
    buscarAsistencia() {
      let me = this;
      let header = { Authorization: "Bearer " + this.$store.state.token };
      let configuracion = { headers: header };
      me.overlay = true;
      axios
        .get(
          "api/Cabinas/DetallexNumAsistencia/" + me.numeroAsistencia,
          configuracion
        )
        .then(function(response) {
          me.overlay = false;
          me.agregarDetalles(response.data);
        })
        .catch(function(error) {
          console.log(error);
          me.overlay = false;
          me.snackError = true;
        });
    },
    agregarDetalles(item) {
      this.idCabina = item[0].idCabina;
      this.idBase = item[0].idBase;
      this.idUsuario = item[0].idUsuario;
      this.idProveedor = item[0].idProveedor;
      this.placa = item[0].placa;
      this.marca = item[0].marcaBase;
      this.modelo = item[0].modeloBase;
      this.año = item[0].añoBase;
      this.fechaContacto = item[0].fechaHoraContacto;
      this.fechaTermino = item[0].termino;
      if (this.fechaContacto != null) {
        this.disabledContacto = true;
      } else {
        this.disabledContacto = false;
      }
      if (this.fechaTermino != null) {
        this.disabledTermino = true;
      } else {
        this.disabledTermino = false;
      }
    },
    fechaHoraContactoTermino() {
      if (this.numeroAsistencia == "") {
        this.snackErrorContacto = true;
        return;
      } else {
        let today = new Date();
        if (this.banderaContactoTermino == 1) {
          var horaContacto =
            new Date().getHours() +
            ":" +
            new Date().getMinutes() +
            ":" +
            new Date().getSeconds();
          this.fechaContacto =
            today.getFullYear() +
            "-" +
            (today.getMonth() + 1) +
            "-" +
            today.getDate() +
            " " +
            horaContacto;
          this.disabledContacto = true;
          this.actualizarFechasAsistencia();
        }
        if (this.banderaContactoTermino == 2) {
          var horaTermino =
            new Date().getHours() +
            ":" +
            new Date().getMinutes() +
            ":" +
            new Date().getSeconds();
          this.fechaTermino =
            today.getFullYear() +
            "-" +
            (today.getMonth() + 1) +
            "-" +
            today.getDate() +
            " " +
            horaTermino;
          this.disabledTermino = true;
          this.actualizarFechasAsistencia();
        }
      }
    },
    openDialogFecha(numero) {
      this.dialogConfirmarFecha = true;
      if (numero == 1) {
        this.banderaContactoTermino = 1;
        this.tituloFecha = "contacto";
      }
      if (numero == 2) {
        this.banderaContactoTermino = 2;
        this.tituloFecha = "termino";
      }
    },
    actualizarFechasAsistencia() {
      let header = { Authorization: "Bearer " + this.$store.state.token };
      let configuracion = { headers: header };
      let me = this;
      me.overlayDate = true;
      axios
        .put(
          "api/Cabinas/AsistenciaProveedor",
          {
            idCabina: me.idCabina,
            idBase: me.idBase,
            idUsuario: me.idUsuario,
            idProveedor: me.idProveedor,
            fechaHoraContacto: me.fechaContacto,
            termino: me.fechaTermino,
          },
          configuracion
        )
        .then(function(response) {
          if (response.status == 200) {
            me.overlayDate = false;
            me.dialogConfirmarFecha = false;
          }
        })
        .catch(function(error) {
          console.log(error);
          me.overlayDate = false;
          me.snackError = true;
        });
    },
    limpiar() {
      this.items = [];
      this.idCabina = "";
      this.idUsuario = "";
      this.idBase = "";
      this.idProveedor = "";
      this.numeroAsistencia = "";
      this.placa = "";
      this.marca = "";
      this.modelo = "";
      this.año = "";
      this.fechaContacto = null;
      this.fechaTermino = null;
    },
    //////////////////////////// ALMACENAMIENTO DE IMAGENES
    cargarArchivos() {
      this.imagenesPreview = [];
      this.filesDescargadasAudios = [];
      this.mostrarBotonDescargar = false;
      if (this.filesCargadas.length > 0) {
        this.disabledCargarArchivos = false;
        for (var i = 0; i < this.filesCargadas.length; i++) {
          if (this.filesCargadas[i].type != "audio/mpeg") {
            this.imagenesPreview.push({
              url: URL.createObjectURL(this.filesCargadas[i]),
            });
          } else {
            this.filesDescargadasAudios.push({
              url: URL.createObjectURL(this.filesCargadas[i]),
            });
          }
        }
      } else {
        this.disabledCargarArchivos = true;
      }
    },
    subirArchivos() {
      let me = this;
      if (me.numeroAsistencia == "") {
        me.snackNumeroAsistencia = true;
        return;
      }
      me.overlay = true;
      for (var i = 0; i < me.filesCargadas.length; i++) {
        const storeRef = storage.child(
          me.numeroAsistencia + "/" + me.filesCargadas[i].name
        );
        const subir = storeRef
          .put(me.filesCargadas[i])
          .then(function(snapshot) {
            me.filesCargadas = [];
            me.imagenesPreview = [];
            me.filesDescargadasAudios = [];
            if (i + 1 == me.filesCargadas.length) {
            } else {
              me.snackArchivoSubido = true;
              me.overlay = false;
              me.cargarArchivos();
            }
          })
          .catch(function(error) {
            console.log(error);
          });
      }
    },
  },
};
</script>
